/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';
import type { TypeBulletinGridDto } from './TypeBulletinGridDto';
import {
    TypeBulletinGridDtoFromJSON,
    TypeBulletinGridDtoFromJSONTyped,
    TypeBulletinGridDtoToJSON,
} from './TypeBulletinGridDto';

/**
 * 
 * @export
 * @interface TypeBulletinGridDtoPaginatedResults
 */
export interface TypeBulletinGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof TypeBulletinGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<TypeBulletinGridDto>}
     * @memberof TypeBulletinGridDtoPaginatedResults
     */
    results?: Array<TypeBulletinGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof TypeBulletinGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the TypeBulletinGridDtoPaginatedResults interface.
 */
export function instanceOfTypeBulletinGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TypeBulletinGridDtoPaginatedResultsFromJSON(json: any): TypeBulletinGridDtoPaginatedResults {
    return TypeBulletinGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function TypeBulletinGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TypeBulletinGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(TypeBulletinGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function TypeBulletinGridDtoPaginatedResultsToJSON(value?: TypeBulletinGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(TypeBulletinGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

